import { List, Typography } from 'antd';
import { ListItemMetaProps } from 'antd/lib/list';
import { memo } from 'react';
import { components, defaultTheme } from 'react-select';
import styled, { css } from 'styled-components';
import { Short01, SingleLineEllipsis } from '../../styles';
import { Avatar } from '../avatar';
import { OptionProps } from './types';

export const StyledTagOption = styled(components.Option).attrs({
  theme: {
    ...defaultTheme,
  },
})<OptionProps>``;

export const ListItem = styled(List.Item)<{ isDisabled?: boolean }>`
  padding: 0;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
`;

type MetaProps = ListItemMetaProps & {
  isFocused: boolean;
  isSelected: boolean;
};

export const ListItemMeta = styled(List.Item.Meta)<MetaProps>`
  align-items: center;
  & .ant-list-item-meta-title {
    margin-bottom: 0;
    ${({ isSelected }) =>
      isSelected
        ? css`
            color: var(--white-100) !important;
          `
        : css`
            color: var(--gray-100);
          `};
  }
  & .ant-list-item-meta-description {
    font-size: var(--font-size-sm);
    ${({ isSelected }) =>
      isSelected
        ? css`
            color: var(--white-100);
          `
        : css`
            color: var(--gray-100);
          `};
    font-weight: normal;
    ${SingleLineEllipsis};
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const TextWrapper = styled.div`
  width: 98%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${Short01};
  > span {
    color: inherit;
  }
`;

export const TitleWrapper = ({ title }) => {
  const { Text } = Typography;

  return (
    <Wrapper data-cy={`tag-option-${title}`}>
      <TextWrapper>
        <Text ellipsis={{ tooltip: true }}>{title}</Text>
      </TextWrapper>
    </Wrapper>
  );
};

export const AvatarOption = memo((props: OptionProps): React.JSX.Element => {
  const { data, isSelected, isFocused, isDisabled } = props;

  return (
    <StyledTagOption {...props}>
      <ListItem data-cy="list-item-user" isDisabled={isDisabled}>
        <ListItemMeta
          isFocused={isFocused}
          isSelected={isSelected}
          avatar={
            <Avatar
              name={data.__isNew__ ? data.value.toString() : data.label}
              src={data.imageUrl}
              userStatus={data.userStatus}
              companyLogoUrl={data.logoUrl}
            />
          }
          title={<TitleWrapper title={data.label} />}
          description={data.description}
        />
      </ListItem>
    </StyledTagOption>
  );
});

AvatarOption.displayName = 'AvatarOption';
